import MyExpApi from "apps/myExperience/enum/MyExpApi";
import client from "shared/datasource/apiClient";
import { ApiOptionSearchRequest } from "shared/types/ApiOptionSearchRequest";

export async function asyncFieldOptionsFn({
  contextId,
  searchKey,
  contextType,
  fieldRenderSubType,
  resultCount,
  participantId
}: ApiOptionSearchRequest) {
  return client(MyExpApi.GET_OPTION_FOR_FIELD, {
    body: {
      contextId,
      searchKey,
      contextType,
      fieldRenderSubType,
      resultCount,
      participantId
    }
  });
}
